(() => {
  if(window.joffzNativeCarousels) return;
  window.joffzNativeCarousels=true;
  function mount(){document.querySelectorAll('[data-joffz-carousel]').forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='true';
    const rail=root.querySelector('[data-joffz-carousel-scroll]'),prev=root.querySelector('[data-joffz-carousel-prev]'),next=root.querySelector('[data-joffz-carousel-next]');
    if(!rail||!prev||!next)return;
    const update=()=>{prev.disabled=rail.scrollLeft<=2;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;};
    const move=direction=>rail.scrollBy({left:direction*rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    let frame=0;rail.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=0;update();});},{passive:true});
    window.addEventListener('resize',update,{passive:true});update();
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.addEventListener('shopify:section:load',mount);
})();
